<template>
  <button class="btn" :class="isOpen ? 'btn--active' : ''" @click="toToggle">
    <BriefcaseIcon class="btn__icon" v-if="!isOpen"/>
    <BriefcaseFullIcon class="btn__icon" v-else/>
    <TagLock class="btn__lock" v-if="!hasPaidAccount && !isLoadingUserData"/>
  </button>
</template>

<script setup>
  import { useUserAuth } from '@/Groups/Briefcase/private/imports/userStoreData';
  import { useBriefcaseDropdown } from '@/Groups/Briefcase/private/imports/toggleDropdown';
  //-----------------------------------
  import BriefcaseIcon from '@/Groups/Briefcase/private/svg/BriefcaseIcon.vue';
  import BriefcaseFullIcon from '@/Groups/Briefcase/private/svg/BriefcaseFullIcon.vue';
  import { TagLock } from '@/Groups/Briefcase/private/imports/externalTemplates';
  //-----------------------------------
  const { hasPaidAccount, isLoadingUserData } = useUserAuth();
  //-----------------------------------
  const { isOpen, close, open } = useBriefcaseDropdown();
  //-----------------------------------
  const toToggle = () => {
    if(!hasPaidAccount.value) return;
    isOpen.value ? close() : open();
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>